import Skeleton from "components/Skeleton/Skeleton";
import { Money, MoneyV2 } from "lib/client/bff";
import { useTranslation } from "lib/i18n/client";

import styles from "./PricePerNight.module.css";

const PricePerNight: React.FC<{
  minPrice: Money | MoneyV2;
  originalPrice?: Money | MoneyV2 | null;
  promoName: string | null;
}> = ({ minPrice, originalPrice, promoName }) => {
  const { t } = useTranslation("price");

  return (
    <div className={styles.price}>
      <div>{t("from")}</div>
      <div className={styles.priceAndPromo}>
        <div>
          {originalPrice && (
            <span className={styles.priceOriginal}>
              {t("common:money", { money: originalPrice })}
            </span>
          )}
          <span className={styles.priceAmount}>
            {t("common:money", { money: minPrice })}
          </span>
          <span> /{t("night")}</span>
        </div>
        {promoName && <div className={styles.priceDiscount}>{promoName}</div>}
      </div>
    </div>
  );
};

export const PricePerNightSkeleton = () => {
  const { t } = useTranslation("price");
  return (
    <div className={styles.price}>
      <div>
        <span>{t("from")} </span>
        <div>
          <span className={styles.priceAmount}>
            <Skeleton width={50} />
          </span>
          <span> /{t("night")}</span>
        </div>
      </div>
    </div>
  );
};

export default PricePerNight;
